import { gql } from '@apollo/client'
import NOTIFICATION_FRAGMENT from 'apollo/fragments/NOTIFICATION_FRAGMENT'

// NOTIFICATION_EVENTS

export default gql`
  subscription NotificationsEvents {
    notification_events {
      event_type
      notification {
        ...NOTIFICATION_FRAGMENT
      }
    }
  }
  ${NOTIFICATION_FRAGMENT}
`
